<template>
  <div class="stella-routing-screen">
    <!-- Ambient background glow orbs matching Stella design system -->
    <div class="routing-orb orb-1"></div>
    <div class="routing-orb orb-2"></div>

    <div class="routing-content text-center">
      <!-- Animated Brand Spinner -->
      <div class="position-relative d-inline-flex align-items-center justify-content-center mb-3">
        <div class="routing-spinner"></div>
        <div class="routing-icon-badge">
          <span class="routing-sparkle">✦</span>
        </div>
      </div>

      <h5 class="text-white font-weight-600 mb-1 font-size-16">Welcome back to Stella</h5>
      <p class="text-muted font-size-13 mb-0">Loading your account...</p>
    </div>
  </div>
</template>

<script>
import {httpMixin} from "@/mixin/http-mixin";
import {mapActions, mapGetters} from "vuex";
import {geDecodedToken} from "@/common/http-common";
import {ACCESS_TOKEN} from "@/properties/close-friend";
import {SERVICE_CONTENT, SERVICE_IDENTIY, SERVICE_SUBSCRIPTION} from "@/properties/micro-service";

export default {
  name: "CustomerRouter",
  mixins: [httpMixin],
  data() {
    return {
      safetyTimeout: null
    };
  },
  created() {
    this.routeCustomer();
    // Safety fallback: if network hangs or delays, route to dashboard after 6s
    this.safetyTimeout = setTimeout(() => {
      if (this.$route.name === 'CustomerRouter') {
        this.$router.replace({name: 'CustomerDashboardMobile'});
      }
    }, 6000);
  },
  beforeDestroy() {
    if (this.safetyTimeout) {
      clearTimeout(this.safetyTimeout);
    }
  },
  methods: {
    ...mapGetters(['getUser', 'getInvitee', 'getInfluencerPlatformId', 'getRedirectTo']),
    ...mapActions(['setUser', 'setInvitee', 'setRedirectTo']),
    routeCustomer() {
      let decoded = null;
      try {
        decoded = geDecodedToken(ACCESS_TOKEN);
      } catch (e) {
        decoded = null;
      }
      if (!decoded || !decoded.id) {
        this.$router.replace({name: 'HomePage'});
        return;
      }
      let customerId = decoded.id;
      let url = `${SERVICE_IDENTIY}/api/v1/customers/${customerId}`;
      this.getData(url, (customer) => {
        this.setUser(customer);
        if (this.$route.params.urlPrefix) {
          let invitee = this.$route.params.urlPrefix;
          this.getUnSecureData(`${SERVICE_IDENTIY}/api/v1/influencers/urlSuffix/${invitee}`, (influencer) => {
            const infPlatformId = this.getInfluencerPlatformId ? this.getInfluencerPlatformId() : null;
            this.getData(`${SERVICE_SUBSCRIPTION}/api/v1/customers/${customerId}/subscriptions/influencer-platform/${infPlatformId}/active`, (activeSub) => {
              if (activeSub) {
                this.routeToBonus(customerId);
              } else {
                this.setInvitee(influencer);
                this.$router.push({name: 'Subscription'});
              }
            });
          });
        } else {
          this.routeToBonus(customerId);
        }
      });
    },
    routeToBonus(customerId) {
      let redirectTo = this.getRedirectTo ? this.getRedirectTo() : null;
      if (redirectTo && redirectTo.chatMessage) {
        this.setRedirectTo(null);
        this.$router.push({name: 'CustomerDirectMessage', params: {customerId: redirectTo.chatMessage}});
      } else {
        let url = `${SERVICE_CONTENT}/api/v1/customers/${customerId}/content/available`;
        this.getData(url, (contentAvailable) => {
          if (contentAvailable) {
            this.$router.replace({name: 'CustomerBonusContentList'});
          } else {
            this.$router.replace({name: 'CustomerDashboardMobile'});
          }
        });
      }
    }
  }
}
</script>

<style scoped>
.stella-routing-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: #08080a;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow: hidden;
}

.routing-content {
  position: relative;
  z-index: 2;
}

.routing-spinner {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.08);
  border-top: 3px solid #E53BB9;
  border-right: 3px solid #F3DA6B;
  animation: stella-spin 0.85s cubic-bezier(0.5, 0.1, 0.4, 0.9) infinite;
}

.routing-icon-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
}

.routing-sparkle {
  background: linear-gradient(135deg, #F3DA6B 0%, #E53BB9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  line-height: 1;
}

.routing-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.22;
  pointer-events: none;
}

.orb-1 {
  width: 340px;
  height: 340px;
  top: 25%;
  left: 20%;
  background: radial-gradient(circle, #E53BB9 0%, transparent 70%);
}

.orb-2 {
  width: 320px;
  height: 320px;
  bottom: 25%;
  right: 20%;
  background: radial-gradient(circle, #70D5C2 0%, transparent 70%);
}

@keyframes stella-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
